/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { take } from 'rxjs/operators';

import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import { TrafficLogCinematicStore } from '../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';
import * as l10n from './log-cinematic-section-security.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Component for displaying Security section in a traffic log cinematic view.
 * @author Kondiparthi Shanmukha Sarath, Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-section-security',
    templateUrl: './log-cinematic-section-security.component.html',
})
export class LogCinematicSectionSecurityComponent {
    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    public readonly icapLog$ = this.logCinematicStore.icapLog$;

    public readonly wafLog$ = this.logCinematicStore.wafLog$;

    public readonly botManagementLog$ = this.logCinematicStore.botManagementLog$;

    /**
     * Total number of ICAP violations summed from the ICAP OPSWAT Log of ICAP Request Logs.
     */
    public totalNumberOfIcapViolations = 0;

    constructor(
        l10nService: L10nService,
        private readonly logCinematicStore: TrafficLogCinematicStore,
    ) {
        l10nService.registerSourceBundles(dictionary);

        this.icapLog$
            .pipe(take(1))
            .subscribe(icapLog => {
                if (icapLog) {
                    const { request_logs: requestLogs } = icapLog;

                    if (requestLogs) {
                        this.totalNumberOfIcapViolations = requestLogs.reduce(
                            (acc, current) => acc + (current.opswat_log?.violations?.length || 0),
                            0,
                        );
                    }
                }
            });
    }
}
